
import { defineComponent, PropType, computed } from "vue";
import { SharingNetworks } from "@models/enums";

export default defineComponent({
  name: "CiContentsActions",
  props: {
    content: {
      type: Object as PropType<Contents.Content>,
      required: true,
    },
  },
  setup(props) {
    const shareTrackingTarget = computed(() => ({
      name: props.content.content_type,
      identifier: props.content.id.toString(),
    }));

    return {
      shareTrackingTarget,
    };
  },
  computed: {
    sharingNetworks(): SharingNetworks[] {
      return [
        SharingNetworks.CustomEmail,
        SharingNetworks.CustomMessaging,
        SharingNetworks.LinkedIn,
        SharingNetworks.Twitter,
        SharingNetworks.Facebook,
      ];
    },
  },
});
